import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "sidebarMenu",
  class: "col-md-3col-lg-2 col-xxl-2 col-xl-3 d-md-block bg-white sidebar h-100 shadow-sm border-end offcanvas offcanvas-start",
  tabindex: "-1"
}
const _hoisted_2 = { class: "position-sticky pt-3 offcanvas-body" }
const _hoisted_3 = { class: "nav flex-column" }
const _hoisted_4 = { class: "nav flex-column" }

import { computed } from "vue";
import GuiidePlusView from "@/guiide/ts/guiideplus/guiidePlusView";
import SideBarNavItem from "@/guiide/components/guiideplus/SideBarNavItem.vue";
import { MenuItem } from "@/guiide/ts/configuration/menuItem";
import { useStore } from "vuex";

type MenuItemPresentationInfo = { item: MenuItem, text: string, iconClass: string, view: GuiidePlusView };

export default /*@__PURE__*/_defineComponent({
  __name: 'SideBar',
  props: {
  selectedView: { default: GuiidePlusView.Dashboard }
},
  emits: ["item-selected"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useStore();

const showHome = computed<boolean>(() => store.state.configuration.nav.guiidePlus.home.visible);
const showMainJourney = computed<boolean>(() => store.state.configuration.nav.guiidePlus.mainJourney.visible);
const providersText = computed<string>(() => store.state.configuration.providersShowsRetailers ? "Providers" : "Cost Comparison");

const allMenuPresenationInfo = computed<Array<MenuItemPresentationInfo>>(() => [
  { item: store.state.configuration.nav.guiidePlus.pensionManagement, view: GuiidePlusView.PensionManagement, text: "[Product Name]", iconClass: "bi-robot text-success" },
  { item: store.state.configuration.nav.guiidePlus.providers, view: GuiidePlusView.Providers, text: providersText.value, iconClass: "bi-piggy-bank" },
  { item: store.state.configuration.nav.guiidePlus.advisers, view: GuiidePlusView.Advisers, text: "Advisers", iconClass: "bi-signpost-2" },
  { item: store.state.configuration.nav.guiidePlus.guaranteedIncome, view: GuiidePlusView.GuaranteedIncome, text: "Guaranteed income", iconClass: "bi-shield-check" },
  { item: store.state.configuration.nav.guiidePlus.statePensionHelp, view: GuiidePlusView.StatePensionHelp, text: "State Pension help", iconClass: "bi-flag" },
  { item: store.state.configuration.nav.guiidePlus.benefitsAndCredits, view: GuiidePlusView.BenefitsAndCredits, text: "Benefits & credits", iconClass: "bi-cash-stack" },
  { item: store.state.configuration.nav.guiidePlus.lumpsSumsAndTax, view: GuiidePlusView.LumpsSumsAndTax, text: "Lumps sums & tax", iconClass: "bi-plus-square" },
  { item: store.state.configuration.nav.guiidePlus.equityRelease, view: GuiidePlusView.EquityRelease, text: "Equity release", iconClass: "bi-house" },
  { item: store.state.configuration.nav.guiidePlus.partnersIncome, view: GuiidePlusView.PartnersIncome, text: "Partners income", iconClass: "bi-people" },
  { item: store.state.configuration.nav.guiidePlus.helpAndEducation, view: GuiidePlusView.HelpAndEduction, text: "Help & education", iconClass: "bi-journal-check" },
  { item: store.state.configuration.nav.guiidePlus.whyPayMore, view: GuiidePlusView.WhyPayMore, text: "Why put in more", iconClass: "bi-graph-up-arrow" },
  { item: store.state.configuration.nav.guiidePlus.otherWaysToSave, view: GuiidePlusView.OtherWaysToSave, text: "Other ways to save", iconClass: "bi-shuffle" },
  { item: store.state.configuration.nav.guiidePlus.financialCoaching, view: GuiidePlusView.FinancialCoaching, text: "Financial coaching", iconClass: "bi-mortarboard-fill" },
]);

function onItemClick(item) {
  emit("item-selected", item);
}

function onMainJourneyClick() {
  window.location.href = "/home/userhome";
}

function onUserHomeClick() {
  window.location.href = "/";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "mobile-nav d-xxl-none d-xl-none mt-3" }, [
      _createElementVNode("a", {
        class: "btn btn-primary",
        "data-bs-toggle": "offcanvas",
        href: "#sidebarMenu",
        role: "button",
        "aria-controls": "sidebarMenu"
      }, [
        _createElementVNode("i", { class: "bi bi-list" }),
        _createTextVNode(" Menu ")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "offcanvas-header" }, [
        _createElementVNode("button", {
          type: "button",
          class: "btn-close text-reset",
          "data-bs-dismiss": "offcanvas",
          "aria-label": "Close"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          _createVNode(SideBarNavItem, {
            itemView: _unref(GuiidePlusView).Dashboard,
            selectedView: __props.selectedView,
            text: "Dashboard",
            iconClass: "bi-speedometer",
            "data-bs-dismiss": "offcanvas",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onItemClick(_unref(GuiidePlusView).Dashboard)))
          }, null, 8, ["itemView", "selectedView"]),
          _withDirectives(_createVNode(SideBarNavItem, {
            selectedView: __props.selectedView,
            text: "Home",
            "transitory-only": true,
            iconClass: "bi-house",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (onUserHomeClick()))
          }, null, 8, ["selectedView"]), [
            [_vShow, showHome.value]
          ]),
          _withDirectives(_createVNode(SideBarNavItem, {
            selectedView: __props.selectedView,
            text: "Main journey",
            "transitory-only": true,
            iconClass: "bi-window",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (onMainJourneyClick()))
          }, null, 8, ["selectedView"]), [
            [_vShow, showMainJourney.value]
          ])
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allMenuPresenationInfo.value, (menuItem) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: menuItem.view
            }, [
              (menuItem.item.visible)
                ? (_openBlock(), _createBlock(SideBarNavItem, {
                    key: 0,
                    "item-view": menuItem.view,
                    "selected-view": __props.selectedView,
                    text: menuItem.text,
                    "icon-class": menuItem.iconClass,
                    "data-bs-dismiss": "offcanvas",
                    onClick: ($event: any) => (onItemClick(menuItem.view))
                  }, null, 8, ["item-view", "selected-view", "text", "icon-class", "onClick"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ])
    ])
  ], 64))
}
}

})